import { render } from "./FaqCallCenterView.vue?vue&type=template&id=1770e86c&scoped=true"
import script from "./FaqCallCenterView.vue?vue&type=script&lang=js"
export * from "./FaqCallCenterView.vue?vue&type=script&lang=js"

import "./FaqCallCenterView.vue?vue&type=style&index=0&id=1770e86c&scoped=true&lang=scss"
import "./FaqCallCenterView.vue?vue&type=style&index=1&id=1770e86c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1770e86c"]])

export default __exports__